import { Box, Flex, HStack, Img, Text } from '@chakra-ui/react';
import BowlDarkImage from 'assets_2/images/logo/bowl-dark-shadow.webp';
import { numberConvert } from 'helpers/numerals';
import React from 'react';
import useGlobalStats from 'services/admin/hooks/useGlobalStats';
import DownloadAppQrCode from './DownloadAppQrCode';

interface DownloadAppBannerAndQrCodeProps {
  downloadLink?: string;
  backgroundColor?: string;
}

const DownloadAppBannerAndQrCode = ({
  downloadLink,
  backgroundColor = 'black'
}: DownloadAppBannerAndQrCodeProps) => {
  const { total_users, isGlobalStatsLoading } = useGlobalStats();
  const numberOfJoinedUsers = numberConvert(total_users ?? 0, true, 0);

  return (
    <Flex
      padding="10px 10px 10px 20px"
      bgColor={backgroundColor}
      borderRadius="20px"
      height="auto"
      minHeight="120px"
    >
      <Box maxWidth="190px" alignSelf="center" marginRight="15px">
        <Text
          fontSize="15px"
          lineHeight="19px"
          fontWeight={700}
          color="neutral.0"
          marginBottom="14px"
          fontFamily="ProximaNova"
        >
          Trusted by {!isGlobalStatsLoading ? numberOfJoinedUsers : null}{' '}
          people. It&apos;s free.
        </Text>
        <HStack spacing="5px">
          <Img
            width="20px"
            htmlWidth="20px"
            height="auto"
            src={BowlDarkImage}
            alt="Insight Timer"
          />
          <Text
            fontSize="12.5px"
            lineHeight="19.17px"
            fontWeight={400}
            color="neutral.0"
            fontFamily="ProximaNova"
          >
            Get the app
          </Text>
        </HStack>
      </Box>

      <Box flexShrink={0}>
        <DownloadAppQrCode downloadLink={downloadLink} />
      </Box>
    </Flex>
  );
};

export default DownloadAppBannerAndQrCode;
